(function(){

  function positionBtn(btn) {
    var wrapper = btn.closest('.card-wrapper');
    if (!wrapper) return;
    var mediaEl = wrapper.querySelector('.card__media');
    if (!mediaEl) return;
    var imgRect = mediaEl.getBoundingClientRect();
    var wrapRect = wrapper.getBoundingClientRect();
    btn.style.bottom = (wrapRect.bottom - imgRect.bottom + 10) + 'px';
  }

  function positionButtons() {
    document.querySelectorAll('.patschy-atc-link').forEach(positionBtn);
  }

  function addPlusSpans() {
    document.querySelectorAll('.patschy-atc-link').forEach(function(btn) {
      if (!btn.querySelector('.patschy-atc-plus')) {
        var span = document.createElement('span');
        span.className = 'patschy-atc-plus';
        span.textContent = '+';
        btn.appendChild(span);
      }
    });
  }

  function observeImages() {
    document.querySelectorAll('.card__media img').forEach(function(img) {
      if (img.complete) {
        positionButtons();
      } else {
        img.addEventListener('load', positionButtons);
        img.addEventListener('error', positionButtons);
      }
    });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.patschy-atc-link');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({id: parseInt(vid, 10), quantity: 1})
    })
    .then(function(r){ return r.json(); })
    .then(function() {
      btn.classList.add('patschy-added');
      setTimeout(function() { btn.classList.remove('patschy-added'); }, 700);
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
        document.querySelectorAll('.cart-count-bubble span').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      });
    })
    .catch(function() { console.error('ATC Fehler'); });
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    positionButtons();
    addPlusSpans();
    observeImages();
  });

  window.addEventListener('resize', positionButtons);
  window.addEventListener('load', function() {
    positionButtons();
    addPlusSpans();
  });

})();
